import { render, staticRenderFns } from "./OverlayImage.vue?vue&type=template&id=04555c8c&scoped=true&"
import script from "./OverlayImage.vue?vue&type=script&lang=js&"
export * from "./OverlayImage.vue?vue&type=script&lang=js&"
import style0 from "./OverlayImage.vue?vue&type=style&index=0&id=04555c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04555c8c",
  null
  
)

export default component.exports